import React, { useState, useEffect } from 'react';
import './AboutMe.css';

const AboutMe = () => {
  const images = [
    '/attachment/tb1.jpg',
    '/attachment/tb2.jpg',
    '/attachment/tb3.jpg',
    '/attachment/tb4.jpg',
    '/attachment/tb5.jpg',
    '/attachment/tb6.jpg',
    '/attachment/tb7.jpg',
    '/attachment/tb8.jpg',
    '/attachment/tb9.jpg',
    '/attachment/tb41.jpg',
    '/attachment/tb18.jpg',
    '/attachment/tb10.jpg',
    '/attachment/tb11.jpg',
    '/attachment/tb12.jpg',
    '/attachment/tb13.jpg',
    '/attachment/tb14.jpg',
    '/attachment/tb15.jpg',
    '/attachment/tb16.jpg',
    '/attachment/tb17.jpg',
    '/attachment/tb19.jpg',
    '/attachment/tb20.jpg',
    '/attachment/tb21.jpg',
    '/attachment/tb22.jpg',
    '/attachment/tb23.jpg',
    '/attachment/tb24.jpg',
    '/attachment/tb25.jpg',
  ];
  const slides = [
    { image: '/attachment/coding.jpg', topic: 'Developing', content: 'I have a passion for working on new projects, always eager to dive into fresh challenges and explore innovative solutions.' },
    { image: '/attachment/trip.jpg', topic: 'Traveling', content: 'Exploring new places, meeting new people, and immersing myself in different cultures excites me.' },
    { image: '/attachment/food.jpg', topic: 'Food', content: 'I enjoy exploring different cuisines and experimenting with new recipes in the kitchen.' },
    { image: '/attachment/travel.png', topic: 'Taking Photos', content: 'Capturing moments, emotions, and the beauty of nature through photography is one of my passions.' },
    { image: '/attachment/cat.jpg', topic: 'Cat', content: "I love spending time with my cat, as they bring a unique kind of joy and companionship that is truly unmatched." },
    { image: '/attachment/dota.jpg', topic: 'Gaming', content: "I enjoy playing video games, especially DOTA with friends, making every match fun." },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const changeSlide = (index) => setCurrentSlide(index);
  const openImageModal = (img) => setSelectedImage(img);
  const closeImageModal = () => setSelectedImage(null);

  useEffect(() => {
    const gallery = document.querySelector('.masonry-gallery');
    const masonryItems = document.querySelectorAll('.masonry-item');

    const resizeAll = () => {
      const rowHeight = parseInt(window.getComputedStyle(gallery).getPropertyValue('grid-auto-rows'));
      const rowGap = parseInt(window.getComputedStyle(gallery).getPropertyValue('gap'));
      masonryItems.forEach((item) => {
        const img = item.querySelector('img');
        if (img.complete) {
          const contentHeight = img.getBoundingClientRect().height;
          item.style.gridRowEnd = `span ${Math.ceil((contentHeight + rowGap) / (rowHeight + rowGap))}`;
        }
      });
    };

    masonryItems.forEach((item) => {
      const img = item.querySelector('img');
      img.addEventListener('load', resizeAll);
      if (img.complete) resizeAll();
    });
    window.addEventListener('resize', resizeAll);

    return () => {
      window.removeEventListener('resize', resizeAll);
    };
  }, []);

  return (
    <div className="section num6" id="about-me">
      <section className="about-me-section">
        <h1 className="ABheader">About Me</h1>
        
        {/* Slideshow */}
        <div className="slideshow">
          <div className="slide-left">
            <img src={slides[currentSlide].image} alt={slides[currentSlide].topic} />
          </div>
          <div className="slide-right">
            <div className="slide-content">
              <h2>{slides[currentSlide].topic}</h2>
              <p>{slides[currentSlide].content}</p>
            </div>
            <div className="bullets">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`bullet ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => changeSlide(index)}
                ></button>
              ))}
            </div>
          </div>
        </div>

        {/* Masonry Gallery */}
        <div className="masonry-gallery">
          {images.map((img, index) => (
            <div className="masonry-item" key={index}>
              <img
                src={img}
                alt={`Image ${index + 1}`}
                onClick={() => openImageModal(img)}
              />
            </div>
          ))}
        </div>

        {/* Modal for Enlarged Image */}
        {selectedImage && (
          <div className="modal" onClick={closeImageModal}>
            <img
              src={selectedImage}
              alt="Enlarged view"
              onClick={(e) => e.stopPropagation()}
            />
            <button className="modal-close" onClick={closeImageModal}>
              &times;
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default AboutMe;
